export interface GuideDate {
  publishedIso: string;
  publishedLabel: string;
  modifiedIso: string;
  modifiedLabel: string;
}

const PUBLISHED_DATES: Record<string, string> = {
  "small-robot-lawn-mowers": "2026-08-25",
  "robot-reel-mowers": "2026-08-23",
  "second-hand-flail-mower-checklist": "2026-08-21",
  "hayes-flail-mowers-overview": "2026-08-19",
  "mowing-steep-slopes-safely": "2026-08-17",
  "best-all-terrain-mowers-australia": "2026-08-15",
  "diy-remote-control-lawn-mower": "2026-08-13",
  "where-to-buy-robot-remote-control-mowers-australia": "2026-08-11",
  "robot-mower-comparison-australia": "2026-08-09",
  "autonomous-mowing-australia-whats-next": "2026-08-07",
  "flail-mower-guide": "2026-08-05",
  "remote-control-flail-mower-guide": "2026-08-03",
  "flail-mower-vs-slasher-vs-mulcher": "2026-08-01",
  "tractor-excavator-flail-mowers-vs-self-propelled": "2026-07-30",
  "flail-mower-buying-guide-australia": "2026-07-28",
  "commercial-remote-control-mowers": "2026-07-26",
  "robot-mowers-for-acreage": "2026-07-24",
  "robot-lawn-mowers-australia-guide": "2026-07-21",
  "robot-mower-vs-remote-control-mower": "2026-07-19",
  "best-robot-lawn-mowers-australia": "2026-07-16",
  "robot-mower-prices-australia": "2026-07-13",
  "best-mower-steep-slopes": "2026-07-11",
  "robot-mowers-australian-acreage-questions": "2026-07-09",
  "remote-controlled-vs-autonomous-mowers": "2026-07-06",
  "flail-mowers-rough-australian-ground": "2026-07-04",
  "compare-remote-controlled-mowers-australia": "2026-07-01",
  "planning-slope-mowing-australian-acreage": "2026-06-28",
  "remote-mower-planning-commercial-vegetation-work": "2026-06-26",
  "bushfire-fuel-reduction-mowing-vs-burning": "2026-06-23",
  "safe-mowing-angles-rollover-risk": "2026-06-21",
  "husqvarna-automower-australia-guide": "2026-06-18",
  "segway-navimow-australia-guide": "2026-06-16",
  "eufy-robot-mower-australia-guide": "2026-06-13",
  "roborock-mower-australia-guide": "2026-06-11",
  "gardena-robot-mower-australia-guide": "2026-06-08",
  "worx-landroid-australia-guide": "2026-06-05",
  "segway-navimow-vs-husqvarna-automower": "2026-06-03",
  "eufy-vs-roborock-robot-mower": "2026-05-31",
  "segway-navimow-vs-eufy-robot-mower": "2026-05-29",
  "robot-mower-bunnings-australia": "2026-05-26",
  "robot-mower-garage-storage-australia": "2026-05-23",
  "wire-free-robot-mowers-rtk-gps": "2026-05-21",
  "cheapest-robot-mowers-australia": "2026-05-18",
  "electric-robot-remote-control-mowers": "2026-05-16",
  "commercial-robot-mowers-australia": "2026-05-13",
  "heavy-duty-awd-robot-mowers": "2026-05-11",
  "flail-mowers-for-tractors-pto-guide": "2026-05-08",
  "excavator-flail-mowers-guide": "2026-05-06",
  "atv-quad-towable-flail-mowers": "2026-05-03",
  "skid-steer-bobcat-flail-mowers": "2026-05-01",
  "flail-mower-blades-hammers-guide": "2026-04-28",
  "flail-mower-hire-australia": "2026-04-26",
  "australian-flail-mower-brands-compared": "2026-04-23",
  "orchard-vineyard-mowing-guide": "2026-04-20",
  "verge-roadside-mowing-councils": "2026-04-18",
};

const MODIFIED_DATES: Record<string, string> = {
  "robot-lawn-mowers-australia-guide": "2026-08-26",
  "best-robot-lawn-mowers-australia": "2026-08-26",
  "flail-mower-guide": "2026-08-25",
  "tractor-excavator-flail-mowers-vs-self-propelled": "2026-08-25",
  "robot-mower-prices-australia": "2026-08-25",
  "flail-mower-buying-guide-australia": "2026-08-26",
  "commercial-remote-control-mowers": "2026-08-25",
  "remote-mower-planning-commercial-vegetation-work": "2026-08-25",
  "segway-navimow-australia-guide": "2026-08-25",
  "eufy-robot-mower-australia-guide": "2026-08-25",
  "worx-landroid-australia-guide": "2026-08-25",
  "segway-navimow-vs-husqvarna-automower": "2026-08-25",
  "eufy-vs-roborock-robot-mower": "2026-08-25",
  "segway-navimow-vs-eufy-robot-mower": "2026-08-25",
  "robot-mower-bunnings-australia": "2026-08-25",
  "australian-flail-mower-brands-compared": "2026-08-26",
};
function formatDate(iso: string) {
  return new Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(`${iso}T00:00:00Z`));
}

const datesNewestFirst = Object.values(PUBLISHED_DATES)
  .map((date) => new Date(`${date}T00:00:00Z`).getTime())
  .sort((a, b) => b - a);

if (new Set(datesNewestFirst).size !== datesNewestFirst.length) {
  throw new Error("Every blog and guide must have a unique publication date");
}

for (let index = 1; index < datesNewestFirst.length; index += 1) {
  const gapInDays =
    (datesNewestFirst[index - 1] - datesNewestFirst[index]) / 86_400_000;
  if (gapInDays !== 2 && gapInDays !== 3) {
    throw new Error(
      "Blog and guide publication dates must be spaced exactly 2 or 3 days apart",
    );
  }
}

export function getGuideDate(slug: string): GuideDate {
  const publishedIso = PUBLISHED_DATES[slug];
  if (!publishedIso) {
    throw new Error(`Missing dedicated publication date for "${slug}"`);
  }

  const publishedLabel = formatDate(publishedIso);
  const modifiedIso = MODIFIED_DATES[slug] ?? publishedIso;
  return {
    publishedIso,
    publishedLabel,
    modifiedIso,
    modifiedLabel: formatDate(modifiedIso),
  };
}
